import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Scrollbars from 'react-custom-scrollbars';
import styled from 'styled-components';
import axios from 'axios';
import { AppModal, AppNoInfo, AppRemixIcon } from '@/layout/AppComponents';
import ReactDOMServer from 'react-dom/server';
import { axiosPath } from '../../../../../../routing/helpers/router';
import Translator from '../../../../../components/helpers/Translator';
import errorHandler from '@/layout/components/error/ErrorHandler';
import colors from '../../../../../../constants/colors';
import GGCLApplicableDateBlock from '../CardElements/GGCLApplicableDateBlock';
import useIsMounted from '../../../../../components/hooks/useIsMounted';

export default function GGCLInformationTab(props) {
  const { moduleBridgeHex, filtersHex } = useParams();
  const { obligationID } = props;
  const dispatch = useDispatch();
  const isMounted = useIsMounted();
  const poLevel1 = useSelector(
    (state) => state.currentPage?.obligationLevels?.level1?.[obligationID],
  );
  const [information, setInformation] = useState();
  const [showLastModificationModal, setShowLastModificationModal] =
    useState(false);

  // > LOAD INFORMATION TAB
  const loadInformationTab = async () => {
    axios
      .post(
        axiosPath(
          'api_r_user_module_globalLegalCompliance_evaluation_tab_information',
        ),
        {
          obligationID,
          filtersHex,
          moduleBridgeHex,
        },
      )
      .then((r) => {
        if (isMounted.current) setInformation(r.data);
      })
      .catch((e) => dispatch(errorHandler(e)));
  };

  useEffect(() => {
    loadInformationTab();
  }, []);
  // < LOAD INFORMATION TAB

  if (!information) return <AppNoInfo minHeight={385} />;

  return (
    <Container>
      <div className="p-3">
        <h3 className="mb-2">{`${poLevel1?.obligation?.category} / ${poLevel1?.obligation?.subcategory} - ${poLevel1?.obligation?.note}`}</h3>
        <Scrollbars style={{ height: '385px', paddingRight: '10px' }}>
          {/* {poLevel1?.obligation?.applicableDate && (
            <div className="font-weight-bold text-danger">
              <Translator
                file="module-legalCompliance"
                name="applicable.from.date"
                variables={{ date: poLevel1?.obligation?.applicableDate }}
              />
            </div>
          )} */}
          <GGCLApplicableDateBlock obligationID={obligationID} />
          {poLevel1?.obligation?.hasFormat ? (
            <div
              dangerouslySetInnerHTML={{
                __html: poLevel1?.obligation?.obligationVersion?.obligation,
              }}
            />
          ) : (
            <div style={{ whiteSpace: 'pre-line' }}>
              {poLevel1?.obligation?.obligationVersion?.obligation}
            </div>
          )}
        </Scrollbars>
      </div>
      <InformationRight className="p-3">
        <Scrollbars style={{ height: '385px', paddingRight: '10px' }}>
          <h4>{`ID: ${poLevel1?.obligation?.id}`}</h4>
          <h4>{`CODE: ${poLevel1?.obligation?.hex || '------'}`}</h4>
          {information?.obligation?.lastModificationDate && (
            <>
              <h4>
                <Translator
                  file="module-legalCompliance"
                  name="signup.modification.date"
                  variables={{
                    date: information.obligation.lastModificationDate.date,
                  }}
                />
                {information?.obligation?.lastModificationDate?.comment && (
                  <AppRemixIcon
                    icon="chat-3"
                    className="ml-1 mr-1 pointer"
                    filled
                    color={colors.primaryLight}
                    onClick={() => setShowLastModificationModal(true)}
                  />
                )}
              </h4>
              {information?.obligation?.lastModificationDate?.comment && (
                <AppModal
                  title={ReactDOMServer.renderToString(
                    <Translator
                      file="module-legalCompliance"
                      name="signup.modification.comment"
                    />,
                  )}
                  show={showLastModificationModal}
                  onClose={() => setShowLastModificationModal(false)}
                >
                  {information?.obligation?.lastModificationDate?.comment}
                </AppModal>
              )}
            </>
          )}
          {poLevel1?.obligation?.obsoleteDate && (
            <h4>{`${ReactDOMServer.renderToString(
              <Translator
                file="module-legalCompliance"
                name="obsolete.date.from"
              />,
            )} : ${poLevel1.obligation.obsoleteDate}`}</h4>
          )}
          {poLevel1?.obligation?.applicableDate && (
            <h4>{`${ReactDOMServer.renderToString(
              <Translator
                file="module-legalCompliance"
                name="applicable.date.from"
              />,
            )} : ${poLevel1.obligation.applicableDate}`}</h4>
          )}
          {information?.obligation?.locations &&
            information?.obligation?.locations.length > 0 && (
              <>
                <h4>
                  <Translator file="location" name="location.title" />:
                </h4>
                <ul>
                  {information?.obligation?.locations.map((loc) => (
                    <li key={loc.id}>
                      <h4>{loc.name}</h4>
                    </li>
                  ))}
                </ul>
              </>
            )}
          {information.categoryGroups &&
            information.categoryGroups.length > 0 && (
              <>
                <h4>
                  <Translator
                    file="module-legalCompliance"
                    name="category.groups"
                  />
                  :
                </h4>
                <ul>
                  {information.categoryGroups.map((cg, i) => (
                    <li key={i}>
                      <h4>{cg}</h4>
                    </li>
                  ))}
                </ul>
              </>
            )}
        </Scrollbars>
      </InformationRight>
    </Container>
  );
}

const Container = styled.div`
  display: grid;
  grid-template-columns: 0.8fr 0.2fr;
  overflow: hidden;
`;

const InformationRight = styled.div`
  border-left: 1px solid #ddd;
  padding: 10px;
`;
